import styled from "styled-components";

const secondary = (props) => props.theme.palette.secondary;
const subgrey = (props) => props.theme.palette.lightgrey;

export const StyledFieldset = styled.fieldset`
  border: 1px solid ${secondary};
  border-left: 6px solid ${secondary};
  padding: 15px;
  border-start-start-radius: 0.275em;
  border-start-end-radius: 0.275em;
  border-end-start-radius: 0.275em;
  border-end-end-radius: 0.875em;

  & legend {
    background-color: ${(props) => props.theme.palette[props.bgcolor]};
    color: ${(props) => props.theme.palette[props.textcolor]};
    font-family: ${(props) => props.theme.fonts.opensans}, sans-serif;
    font-size: 14px;
    padding: 12px;
    width: 98%;
    border-radius: 0.275em;
  }
`;

export const StyledAccordion = styled.div`
  legend {
    font-family: ${(props) => props.theme.fonts.opensans}, sans-serif;
    font-size: 14px;
    width: 100%;
  }

  .MuiAccordionSummary-root {
    background-color: ${(props) =>
      props.theme.palette[props.bgcolor]} !important;
    color: ${(props) => props.theme.palette[props.textcolor]} !important;
  }

  .MuiAccordionDetails-root {
    display: block !important;
  }

  .MuiCollapse-wrapperInner {
    padding: 5px;
  }
  .MuiPaper-root {
    border: 0.725px solid ${subgrey};
    box-shadow: 3px 3px 3px ${subgrey};
  }
`;
